<template>
    <div ref="modal" class="modal-container" v-if="currentModal === id">
        <div class="modal" :class="{'modal-lg': size === 'lg'}">
            <a v-if="showClose" class="modal-close" href="#" @click.prevent="closeModal">
                <span class="sr-only">Close</span>
            </a>

            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: String,
                required: true,
            },

            size: {
                type: String,
                default: () => '',
            },

            showClose: {
                type: Boolean,
                default: () => true,
            },

            open: Function,

            close: Function,
        },

        watch: {
            currentModal(value) {
                if (value) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }

                if (value === this.id && this.open) {
                    this.open();
                }
            },
        },

        destroyed() {
            document.body.classList.remove('overflow-hidden');

            if (this.close) {
                this.close();
            }
        },

        methods: {
            closeModal() {
                if (this.close) {
                    this.close();
                }

                this.hideModal();
            },
        },
    }
</script>
